<div
  class="record"
  [ngClass]="{
    wait: isEmAnalise || isEmFechamento,
    success: isAprovada,
    refused: isRecusada,
    sos: isSos,
    'payment-date': isPagamentoAgendado
  }"
>
  <div
    class="head"
    [ngClass]="{
      'blue-bg': proposta.statusTimeline.idStatus === 31 && isParceiro,
      'orange-bg':
        (proposta.statusTimeline.idStatus === 32 ||
          proposta.statusTimeline.idStatus === 33) &&
        isParceiro
    }"
  >
    <div class="flex-container">
      <span
        *ngIf="proposta.statusEfetive === 'true'"
        class="icon-omni-efetive-mais icon-size-40 margin-left-12"
      ></span>
      <a
        class="margin-auto"
        (click)="clickTituloCard()"
        [title]="titleTituloCard"
        [ngClass]="{
          'a-none': isNoAction
        }"
        >{{ proposta.statusTimeline.tituloStatus }}</a
      >
      <span
        *ngIf="proposta.statusEfetive === 'true'"
        class="icon-omni-efetive-mais icon-size-40 margin-left-12 visibility-hidden"
      ></span>
    </div>
  </div>
  <div class="body">
    <div *ngIf="isCardEsquerdo" class="days col-xs-4">
      <div class="row">
        <div class="col-xs-12">
          <span class="icon"></span>
        </div>
      </div>
      <div *ngIf="isStrongText" class="row">
        <div class="col-xs-12">
          <strong>{{ strongText }}</strong>
        </div>
      </div>
      <div *ngIf="isSmallText" class="row">
        <div class="col-xs-12">
          <small>{{ smallText }}</small>
        </div>
      </div>
      <div *ngIf="isCdclRecusada" class="row">
        <div class="col-xs-12">
          <strong>{{ strongText }}</strong>
        </div>
      </div>
      <div *ngIf="isBotaoAcao" class="row">
        <div class="col-xs-12">
          <a
            (click)="clickBotaoAcao()"
            title="{{ botaoAcao }}"
            class="btn btn-sm"
            >{{ botaoAcao }}</a
          >
        </div>
      </div>
      <div *ngIf="isNovaTentativa" class="row">
        <div class="col-xs-12">
          <span class="fa fa-spinner fa-pulse fa-1x" aria-hidden="true"></span>
          <span>Executando Nova Tentativa...</span>
        </div>
      </div>

      <div *ngIf="isUsuarioAcao" class="row operator">
        <div class="col-xs-12 text-left">
          <img
            class="user-photo margin-0"
            src="{{ proposta.statusTimeline.urlFotoUsuarioAcao }}"
            appFallbackImage
            alt="Foto Usuário"
          />
          <span class="name">
            <span>
              <small>Analista</small>
              {{ proposta.statusTimeline.usuarioAcao }}
            </span>
          </span>
        </div>
      </div>
    </div>
    <div
      class="infos"
      [ngClass]="{ 'col-xs-8': isCardEsquerdo, 'col-xs-12': !isCardEsquerdo }"
    >
      <!-- Número e data -->
      <div class="row date">
        <div class="text-left">
          Ficha: <span>{{ proposta.id }}</span>
          <span
            *ngIf="proposta.tipoUsuarioInclusao === 7"
            class="icon store"
          ></span>
        </div>
        <div class="text-right">
          Iniciada:<span>{{ proposta.dataHoraEnvio | date: 'dd/MM/y' }}</span> |
          <span>{{ proposta.dataHoraEnvio | date: 'HH:mm' }}</span>
          <app-bell-notification
            [count]="proposta.totalSos"
          ></app-bell-notification>
        </div>
      </div>
      <!-- Cliente -->
      <div class="row client">
        <div class="col-xs-12">
          <span class="title">Cliente</span>
          <h2
            *ngIf="proposta.cliente.nome != ' '"
            title="{{ proposta.cliente.nome }}"
          >
            {{ proposta.cliente.nome }}
          </h2>
          <span
            class="user-id"
            [ngStyle]="{
              'font-size.rem': proposta.cliente.nome != ' ' ? 1.2 : 2.5,
              color: proposta.cliente.nome != ' ' ? '#474947' : '#00185c',
              'margin-bottom.px': proposta.cliente.nome != ' ' ? 0 : 13
            }"
            >CPF: {{ proposta.cliente.cpf | cpf }}</span
          >
        </div>
      </div>
      <!-- Representante -->
      <div *ngIf="proposta.vendedor" class="row operator">
        <div class="col-xs-12 text-left">
          <img
            style="margin-left: 6px"
            class="user-photo margin-0"
            src="{{ proposta.vendedor.urlFoto }}"
            alt="Foto Representante"
            appFallbackImage
          />
          <span class="name">
            <span>
              <small>{{ proposta.vendedor.nmLoja | titlecase }}</small>
              {{ proposta.vendedor.nome | titlecase }}
            </span>
          </span>
        </div>
      </div>
      <!-- Lojista -->
      <div *ngIf="proposta.promotor" class="row operator">
        <div class="col-xs-12 text-left">
          <img
            style="margin-left: 6px"
            class="user-photo margin-0"
            src="{{ proposta.promotor.urlFoto }}"
            alt="Foto Logista"
            appFallbackImage
          />
          <span class="name">
            <span>
              {{ proposta.promotor.nome | titlecase }}
            </span>
          </span>
          <div
            class="action"
            *ngIf="proposta.statusTimeline.idStatus === 31 && isParceiro"
          >
            <a
              [routerLink]="[
                '/produtos/cdcloja/ecommerce',
                1,
                this.proposta.id
              ]"
            >
              <span> Continuar Preenchimento </span>
            </a>
            <em class="fa fa-chevron-right"></em>
          </div>
          <div
            class="action"
            *ngIf="proposta.statusTimeline.idStatus === 32 && isParceiro"
          >
            <a
              [routerLink]="[
                '/produtos/cdcloja/ecommerce',
                3,
                this.proposta.id
              ]"
            >
              <span> Verificar Status e Continuar Preenchimento </span>
            </a>
            <em class="fa fa-chevron-right"></em>
          </div>
          <div
            class="action"
            *ngIf="proposta.statusTimeline.idStatus === 33 && isParceiro"
          >
            <a
              [routerLink]="[
                '/produtos/cdcloja/ecommerce',
                3,
                this.proposta.id
              ]"
            >
              <span> Continuar Preenchimento </span>
            </a>
            <em class="fa fa-chevron-right"></em>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal-message
  #modalMessage
  title="Atenção!"
  [hideClose]="true"
></app-modal-message>
